import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreatePhysicalSocketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/create-physical-socket.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { ChargePointChannelPhysicalSocketCreateFormStep1Controller } from '@app/feature/charge-point/charge-point-channel-physical-socket-create/charge-point-channel-physical-socket-create-form-step-1/charge-point-channel-physical-socket-create-form-step-1.controller';
import { useCreateChargePointChannelPhysicalSocketContext } from '@app/feature/charge-point/charge-point.context';

export interface ChargePointChannelPhysicalSocketCreateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<
      CreatePhysicalSocketModel,
      'chargePointId' | 'channelId' | 'physicalSocket'
    >
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<
      CreatePhysicalSocketModel,
      'chargePointId' | 'channelId' | 'physicalSocket'
    >
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelPhysicalSocketCreateFormController = (
  props: ChargePointChannelPhysicalSocketCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useCreateChargePointChannelPhysicalSocketContext();

  return (
    <MultiStepFormProvider<
      Pick<
        CreatePhysicalSocketModel,
        'chargePointId' | 'channelId' | 'physicalSocket'
      >
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'physicalSocket.standard',
            'physicalSocket.format',
            'physicalSocket.amperage',
            'physicalSocket.voltage',
            'physicalSocket.powerType',
          ],
          component: (
            <ChargePointChannelPhysicalSocketCreateFormStep1Controller />
          ),
        },
      ]}
    />
  );
};
